import React, { Fragment } from 'react';
import 'react-image-lightbox/style.css';
import Rating from '../Rating';

const FormsGeneric = ({ form }) => {
  const renderResponse = (response) => {
    if (response.subject.indexOf('image') !== -1) {
      return renderImage(response);
    } else if (response.subject.indexOf('rating') !== -1) {
      return renderRating(response);
    } else {
      return response.response;
    }
  };

  const renderImage = (response) => {
    return response.reference_url ? (
      <>
        <br />
        <img src={response.reference_url} width="100" alt="user content" />
      </>
    ) : null;
  };

  const renderRating = (response) => {
    return <Rating rating={response.response} />;
  };

  return (
    <div>
      {form.responses.map((response) => (
        <Fragment key={response.id}>
          <div>{renderResponse(response)}</div>
        </Fragment>
      ))}
    </div>
  );
};

export default FormsGeneric;
